var _style, _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisualObservation = function SvgVisualObservation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".VisualObservation_svg__st0{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.6c12.9 0 23.4 10.5 23.4 23.4S44.9 55.4 32 55.4 8.6 44.9 8.6 32 19.1 8.6 32 8.6M32 7C18.2 7 7 18.2 7 32s11.2 25 25 25 25-11.2 25-25S45.8 7 32 7",
    className: "VisualObservation_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31.6c-.1-.1-1.6-2-4-4-1.5-1.2-2.9-2.1-4.4-2.7-1.9-.8-3.7-1.3-5.5-1.3s-3.6.4-5.5 1.3c-1.5.7-3 1.6-4.4 2.7-2.5 1.9-4 3.9-4 4l-.5.4.3.4c.1.1 1.6 2 4 4 1.5 1.1 2.9 2.1 4.4 2.7 1.9.8 3.7 1.3 5.5 1.3s3.6-.4 5.5-1.3c1.5-.7 3-1.6 4.4-2.7 2.5-1.9 4-3.9 4-4l.3-.4zm-14 6.9c-3.6 0-6.5-2.9-6.5-6.5s2.9-6.5 6.5-6.5 6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5",
    className: "VisualObservation_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 3.7,
    className: "VisualObservation_svg__st0"
  })));
};
export default SvgVisualObservation;